import React from 'react';
import isEmpty from 'lodash/isEmpty';
import dayjs from 'core/utils/dayjs';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { parseBonusButton } from 'core/modules/BonusButton/utils/parseBonusButton';
import { addCommas } from 'core/utils/helpers/numbers';
import config from 'core/modules/BonusButton/configs';
import { useGetBonusButton } from 'core/modules/BonusButton/hooks/useGetBonusButton';

import './BonusButtonBanner.scss';

function BonusButtonBanner() {
  const { placement } = useGetBonusButton(true);
  const {
    endDate, maxRewardAvailable, minSpendToQualify, brandCurrency, isEnded,
  } = parseBonusButton(placement);

  if (isEmpty(placement) || isEnded) return null;

  const { dateFormat, getBonusText, getTermsText } = config.bannerConfig;
  const endDateFormated = dayjs(endDate).format(dateFormat);
  const bonusText = getBonusText();
  const termsText = getTermsText();

  return (
    <div className="mn_bonusButtonBanner">
      <div className="mn_icon" />
      <div className="mn_details">
        <div className="mn_preTitle">
          Limited-time bonus for first-time installers<span className="mn_colon">:</span>
        </div>
        <h2>Earn {addCommas(maxRewardAvailable)} {bonusText} {brandCurrency}<span className="mn_dot">.</span></h2>
        <p className="mn_info">
          Simply install the button and spend {addCommas(minSpendToQualify)}{' '}
          <span className="mn_noWrap">by {endDateFormated}<span className="mn_dot">.</span>*</span>
        </p>
        {termsText && <div className="mn_terms">{termsText}</div>}
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><BonusButtonBanner {...props} /></ComponentErrorBoundary>;
